// Copies text to the clipboard. navigator.clipboard needs a secure context
// and isn't available in every embedded browser, so fall back to the old
// textarea + execCommand trick there. Resolves to whether copying worked.
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(area);
    return copied;
  }
}

// Where this app is served, so links handed to an assistant point back at
// the same deployment (focussuite.de in production).
export function appBase() {
  return `${window.location.origin}${window.location.pathname.replace(
    /\/$/,
    ""
  )}`;
}
